import { render, staticRenderFns } from "./LogsManagerTable.vue?vue&type=template&id=647f6df4&scoped=true&"
import script from "./LogsManagerTable.vue?vue&type=script&lang=js&"
export * from "./LogsManagerTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647f6df4",
  null
  
)

export default component.exports